import React, { useEffect, useState } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
} from "@mui/icons-material";
import {
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";

const TableFooter = ({
  totalRows,
  rowsPerPage,
  startIndex,
  setStartIndex,
  endIndex,
  setEndIndex,
  setPageNo,
  pageNo,
  totalPages,
  setRowsPerPage,
}) => {
  const [dotHover, setDotHover] = useState(false);

  const handleNextPage = () => {
    if (pageNo + 1 > totalPages) {
      return;
    }
    setPageNo(pageNo + 1);
    if (endIndex >= totalRows) {
      return;
    }
    const newStartIndex = startIndex + Number(rowsPerPage);
    const newEndIndex = endIndex + Number(rowsPerPage);
    // if (newEndIndex <= list.length) {
    setStartIndex(newStartIndex);
    setEndIndex(newEndIndex);
  };

  const handlePrevPage = () => {
    if (pageNo === 1) {
      return;
    }
    setPageNo(pageNo - 1);
    if (startIndex < 1) {
      return;
    }
    const newStartIndex = startIndex - rowsPerPage;
    const newEndIndex = endIndex - rowsPerPage;
    // if (newStartIndex >= 0) {
    setStartIndex(newStartIndex);
    setEndIndex(newEndIndex);
    // }
  };

  const generateVisiblePageNumbers = () => {
    const visiblePages = [];
    const totalPagesToShow = 3; // Number of page numbers to show (including ellipsis if present)

    if (totalPages < totalPagesToShow) {
      // If the total number of pages is less than or equal to the number of pages to show, show all pages
      for (let i = 1; i <= totalPages; i++) {
        visiblePages.push(i);
      }
    } else {
      // Calculate the range of visible page numbers with ellipsis
      const leftOffset = Math.floor((totalPagesToShow - 1) / 2);
      const rightOffset = totalPagesToShow - 1 - leftOffset;

      let startPage = pageNo - leftOffset;
      let endPage = pageNo + rightOffset;
      let totalPagestoShowEdit = 5;

      if (startPage <= 0) {
        startPage = 1;
        endPage = totalPages <= 5 ? totalPages : totalPagestoShowEdit;
      } else if (endPage > totalPages) {
        endPage = totalPages;
        startPage = totalPages - totalPagestoShowEdit + 1;
      }

      for (let i = startPage; i <= endPage; i++) {
        visiblePages.push(i);
      }

      if (startPage > 1) {
        visiblePages.unshift("...");
        visiblePages.unshift(1);
      }
      if (endPage < totalPages) {
        visiblePages.push("...");
        visiblePages.push(totalPages);
      }
    }

    return visiblePages;
  };

  useEffect(() => {
    setStartIndex(Number(rowsPerPage * (pageNo - 1)));
    setEndIndex(Number(rowsPerPage * (pageNo - 1) + rowsPerPage));
  }, [pageNo]);

  return (
    <>
      <div className="assets-footer px-4 max-h-[50px] py-3 bg-white rounded-b-lg">
        <p
          style={{
            width: "180px",
            marginRight: "auto",
          }}
          className="text-xs font-medium text-black"
        >
          <span>{startIndex + 1}</span> -{" "}
          <span>{endIndex > totalRows ? totalRows : endIndex}</span> of{" "}
          <span>{totalRows}</span> items
        </p>
        <div className="flex items-center bg-[#F8F8F8] px-1 py-1 rounded h-[36px]">
          <div className="bg-white flex items-center px-4 py-1 rounded h-[28px]">
            <div className="flex flex-row justify-center items-center">
              <button
                className={`${
                  pageNo === 1 || startIndex < 1
                    ? "text-[#848484] cursor-not-allowed"
                    : "text-[#262626] cursor-pointer"
                } text-xs font-medium mr-2`}
                onClick={() => {
                  setPageNo(1);
                  setStartIndex(0);
                  setEndIndex(rowsPerPage);
                }}
              >
                FIRST
              </button>
              {/* <KeyboardDoubleArrowLeft
              style={{ cursor: "pointer" }}
              onClick={() => {
                setPageNo(1);
                setStartIndex(0);
                setEndIndex(rowsPerPage);
              }}
            /> */}
              <button
                className={`${
                  pageNo === 1 || startIndex < 1
                    ? "text-[#848484] cursor-not-allowed"
                    : "text-[#262626] cursor-pointer"
                } text-sm font-medium flex flex-row justify-center items-center`}
                onClick={handlePrevPage}
              >
                <ChevronLeftIcon />
                PREV
              </button>
            </div>
            <div
              style={{ display: "flex" }}
              className="footer-number-container"
            >
              {/* {pageNo} */}
              {/* {Array(totalPages)
              .fill(null)
              .map((_, index) => (
                <React.Fragment key={index}>
                  {index < 3 || index === 9 ? (
                    <>{index + 1} </>
                  ) : index === 3 ? (
                    " ... "
                  ) : (
                    ""
                  )}
                </React.Fragment>
              ))} */}
              {generateVisiblePageNumbers().map((pageNumber, index) => (
                <React.Fragment key={index}>
                  {pageNumber === "..." ? (
                    dotHover ? (
                      <div
                        className="bg-[#E6EBED] rounded-full w-5 h-5 cursor-pointer"
                        onMouseOut={() => setDotHover(false)}
                      >
                        {index < 2 ? (
                          <MdKeyboardDoubleArrowLeft
                            color="#92E86C"
                            size={"20px"}
                            onClick={() => {
                              if (pageNo - 3 < 1) {
                                setPageNo(1);
                              } else {
                                setPageNo(pageNo - 3);
                              }
                            }}
                          />
                        ) : (
                          <MdKeyboardDoubleArrowRight
                            color="#92E86C"
                            size={"20px"}
                            onClick={() => {
                              if (pageNo + 3 > totalPages) {
                                setPageNo(totalPages);
                              } else {
                                setPageNo(pageNo + 3);
                              }
                            }}
                          />
                        )}
                      </div>
                    ) : (
                      <div
                        className="bg-white rounded-full w-5 h-5 flex justify-center items-center cursor-pointer"
                        onMouseOver={() => setDotHover(true)}
                      >
                        <span>{pageNumber}</span>
                      </div>
                    )
                  ) : (
                    <p
                      onClick={() => {
                        setPageNo(pageNumber);
                      }}
                      className={
                        pageNo === pageNumber
                          ? "bg-[#a0ff77] rounded-full text-sm font-medium text-[#262626] w-fit h-fit"
                          : "bg-white rounded-full text-sm font-medium text-[#262626] w-fit h-fit hover:bg-[#E6EBED]"
                      }
                    >
                      {pageNumber}
                    </p>
                  )}
                </React.Fragment>
              ))}
            </div>
            <div className="flex flex-row justify-center items-center">
              <button
                className={`${
                  pageNo + 1 > totalPages
                    ? "text-[#848484] cursor-not-allowed"
                    : "text-[#262626] cursor-pointer"
                } text-sm font-medium flex flex-row justify-center items-center mr-2`}
                onClick={handleNextPage}
              >
                NEXT
                <ChevronRightIcon />
              </button>
              <button
                className={`${
                  pageNo + 1 > totalPages || endIndex >= totalRows
                    ? "text-[#848484] cursor-not-allowed"
                    : "text-[#262626] cursor-pointer"
                } text-xs font-medium`}
                onClick={() => {
                  if (endIndex < totalRows) {
                    setPageNo(totalPages);
                    setStartIndex(totalRows - rowsPerPage + totalPages);
                    setEndIndex(totalRows);
                  }
                }}
              >
                LAST
              </button>
            </div>
          </div>
        </div>
        <div className="flex items-center ml-auto text-xs">
          <p className="text-[#262626] text-xs font-medium">
            Item per page:&nbsp;&nbsp;
          </p>
          <select
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(e.target.value)}
            className="bg-white text-[#262626] border border-solid border-[#E0E0E0] rounded-md pl-1 py-1"
          >
            {/* <option value={rowsPerPage}>{rowsPerPage}</option> */}
            {Array(10)
              .fill(null)
              .map((_, index) => (
                <option
                  value={index * 5 + 5}
                  selected={index * 5 + 5 === rowsPerPage}
                >
                  {index * 5 + 5}
                </option>
              ))}
          </select>
        </div>
      </div>
    </>
  );
};

export default TableFooter;
